import {  StandardTextFieldProps } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'
import { FC } from 'react'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { StyledTextField } from 'pages/profile/components/edit-member-profile/EditProfilePage'

export interface ITextInputProps extends StandardTextFieldProps {
  width?:string
}

export const TextInput: FC<ITextInputProps> = ({width, ...rest }) => {
  const theme = useTheme()
  const {isDevice} = useScreenSizes()

  return (
      <StyledTextField InputProps={{ disableUnderline: true }}  {...rest} id='input' autoComplete='new-password'/>
  )
}
